import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=46959fd6&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=46959fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46959fd6",
  null
  
)

export default component.exports